module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/tribuo-02bfc2431d88f2083c1f066400e34200.png";